import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProfileMin } from '../../../../profiles/shared/profile-min.model';
import { UtilService, DialogService } from '../../../../shared/index';
import { EventRead } from '../../../shared/event-read.model';
import { RegistrationUpsert } from '../../shared/crud/registration-upsert.model';
import { RegistrationAttendee } from '../../shared/registration-attendee.model';
import { RegistrationAttendeeItem } from '../../shared/registration-attendee-item.model';
import { RegistrationAttendeeItemCustomResponse } from '../../shared/registration-attendee-item-custom-response.model';
import { RegistrationItem } from '../../shared/registration-item.model';
import { RegistrationItemCustomField } from '../../shared/registration-item-custom-field.model';
import { RegistrationItemCustomFieldAvailableValue } from '../../shared/registration-item-custom-field-avail-value.model';
import { RegistrationItemCustomFieldAvailableValueCreditType } from '../../shared/registration-item-custom-field-avail-value-credit-type.model';
import { CreditCardPaymentInfo } from '../../../../revenue/shared/credit-card/credit-card-payment-info.model';
import { IValidationComponent } from '../../../../shared/widgets/component/ivalidation.component';
import { ValidationResult } from '../../../../shared/widgets/validators/validation-result.model';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { EventPaymentMethodService } from '../../../shared/payment-methods/event-payment-method.service';
import { EventPaymentMethod } from '../../../shared/payment-methods/event-payment-method.model';
import { CreditCardService } from '../../../../revenue/shared/credit-card/credit-card.service';
import { CreditCardInputComponent } from '../../../../revenue/credit-card-input/credit-card-input.component';
import { AdjustmentType } from '../../../../revenue/shared/adjustment-types/adjustment-type.model';
import { PaymentType } from '../../../../revenue/shared/payment-types/payment-type.model';

@Component({
  selector: 'wl-registration-wizard-modification-options',
  templateUrl: 'registration-wizard-modification-options.component.html',
  providers: [],
    standalone: false
})
export class RegistrationWizardModificationOptionsComponent implements OnInit, IValidationComponent {
  @Input() public hasPaymentAmount: boolean = true;
  @Input() public hasRefundableCcPayment: boolean = false;

  public _utilService: UtilService;
  public _translationService: TranslationService;

  public registrationId: number;
  public registration: RegistrationUpsert = new RegistrationUpsert();
  public event: EventRead = new EventRead();
  public initialLoadComplete: boolean = false;

  public constructor(utilService: UtilService, translationService: TranslationService) {
    this._utilService = utilService;
    this._translationService = translationService;

    this.registrationId = 0;
  }

  ngOnInit() {}

  public loadData = (): void => {
    this.initialLoadComplete = true;
  };

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();
    valid.isValid = true;

    if (this.registration.ModificationOptions.DoNotModifyInvoice == false) {
      if (
        this.registration.IsEdit &&
        this.registration.ModificationOptions.CreateUnappliedPayments == true &&
        this.registration.ModificationOptions.UnappliedPaymentPaymentypeId <= 0
      ) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-unapplied-payment-type-needed-validation-error'
          )
        );
      }
      if (this.registration.IsEdit && this.hasPaymentAmount && this.registration.ModificationOptions.PaymentAdjustmentTypeId <= 0) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-payment-adjustment-type-needed-validation-error'
          )
        );
      }
      if (this.registration.IsEdit && this.registration.ModificationOptions.InvoiceAdjustmentTypeId <= 0) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-invoice-adjustment-type-needed-validation-error'
          )
        );
      }
    }

    return valid;
  };

  /**
   * don't let Create Unapplied payments and Refund both be selected
   * @param selected
   */
  public handleCreateUnappliedPaymentsChanged(selected: boolean): void {
    if (selected) {
      this.registration.ModificationOptions.RefundCreditCardPayments = false;
    }
  }

  /**
   * don't let Create Unapplied payments and Refund both be selected
   * @param selected
   */
  public handleRefundCreditCardPaymentsChanged(selected: boolean): void {
    if (selected) {
      this.registration.ModificationOptions.CreateUnappliedPayments = false;
    }
  }

  /**
   * don't let Create Unapplied payments and Refund be selected
   * @param selected
   */
  public handleDoNotModifyInvoiceChanged(selected: boolean): void {
    this.registration.ModificationOptions.DoNotModifyInvoice = selected;

    if (selected) {
      this.registration.ModificationOptions.CreateUnappliedPayments = false;
      this.registration.ModificationOptions.RefundCreditCardPayments = false;
    }
  }
}
